if (!customElements.get('delivery-checker')) {
  customElements.define('delivery-checker',
    class DeliveryChecker extends HTMLElement {
      
      constructor() {
        super();

        this.disabled = false;

        // Hide delivery checker on quick add
        if (this.dataset.id.startsWith('quickadd')) {
          this.disabled = true;
          this.classList.toggle('hidden');
          return;
        }

        this.acTo = null;
        this.acFrom = null;
        this.cartAttributes = {
          deliveryTo: '',
          pickupFrom: ''
        }
      }

      elements = {
        deliveryToField: this.querySelector('[data-delivery-to]'),
        pickupFromField: this.querySelector('[data-pickup-from]'),
        checkbox: this.querySelector('[data-checkbox-no-pickup]')
      }

      connectedCallback() {

        // Return inmediately if the delivery checker is disabled
        if ( this.disabled ) return;

        this.acFrom = new AutoCompletion({ inputField: this.elements.deliveryToField });
        this.acTo = new AutoCompletion({ inputField: this.elements.pickupFromField });

        // on load, set the values of the cart attributes if any
        this.cartAttributes.deliveryTo = this.elements.deliveryToField.value;
        this.cartAttributes.pickupFrom = this.elements.pickupFromField.value;

        this.bindEvents();
      }

      bindEvents() {
        this.elements.checkbox.addEventListener('change', () => {
          this.elements.pickupFromField.disabled = this.elements.checkbox.checked;
          this.elements.pickupFromField.value = '';
          this.cartAttributes.pickupFrom = ''
          this.updateCartAttributes();
        });
        this.addEventListener('ac:location:updated', this.events.handleLocationUpdate);
      }

      events = {
        handleLocationUpdate: (e) => {
          if (e.target.name === 'delivery') {
            this.cartAttributes.deliveryTo = e.detail.location.formattedAddress;
          }
          if (e.target.name === 'pickup') {
            this.cartAttributes.pickupFrom = e.detail.location.formattedAddress;
          }

          this.updateCartAttributes();
        }
      }

      updateCartAttributes() {

        const body = JSON.stringify({
          attributes: this.cartAttributes
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('Failed to update cart attributes');
          })
          .then(cart => {
            // Handle success response
            console.log('Cart attributes updated:', cart.attributes);
            // You can update your UI or perform other actions here
            publish(PUB_SUB_EVENTS.cartUpdate, { source: this, cartData: cart });
          })
          .catch(error => {
            // Handle error
            console.error('Error updating cart attributes:', error);
          });
      }

    }
  );
}